import React, { useState, useContext } from "react";
import axiosHttp from "../config/axios.interceptor";
import { AppContext } from "../contexts/AppContext";
import { AuthContext } from "../contexts/AuthContext";
import { errorResponseMessage } from "../shared/const.prop";

const ReportPost = ({ data }) => {
  const { id } = data;
  const [report, setReport] = useState("");
  const [show, setShow] = useState(false);
  const appContext = useContext(AppContext);
  const authContext = useContext(AuthContext);

  const handleChange = (e) => {
    if (e.target.value === "other") {
      setShow(true);
    }
    setReport(e.target.value);
  };

  const submitHandler = async () => {
    try {
      let payload = {
        comments: report,
      };
      const reportPost = await axiosHttp.post(`post/${id}/report`, {
        ...payload,
      });
      if (reportPost.status === 201) {
        appContext.updateModalState(false);
        if (data.type === "reels") {
          appContext.updateNotificationState({
            type: "success",
            message: "Reels reported successfully",
            show: true,
          });
        } else {
          appContext.updateNotificationState({
            type: "success",
            message: "Post reported successfully",
            show: true,
          });
        }
      }
    } catch (error) {
      if (error.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
        authContext.logout();
      }
      if (error.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
      }
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
    }
  };

  return (
    <div className="m-4">
      {!show && (
        <div className="row">
          <select className="form-control" onChange={handleChange}>
            <option value="">Please Select</option>
            <option value="Harrassment">Harrassment</option>
            <option value="Fraud or Scam">Fraud or Scam</option>
            <option value="Spam">Spam</option>
            <option value="MisInformation">MisInformation</option>
            <option value="Hateful Speech">Hateful Speech</option>
            <option value="Threats or violence">Threats or violence</option>
            <option value="Self-harm">Self-harm</option>
            <option value="Graphic content">Graphic content</option>
            <option value="Dangerous or extremist organizations">
              Dangerous or extremist organizations
            </option>
            <option value="Sexual content">Sexual content</option>
            <option value="Fake Account">Fake Account</option>
            <option value="Illegal goods and services">
              Illegal goods and services
            </option>
            <option value="Infringement or defamation">
              Infringement or defamation
            </option>
            <option value="other">Other</option>
          </select>
        </div>
      )}
      {show && (
        <div className="row">
          <input
            type="text"
            className="form-control"
            onChange={(e) => setReport(e.target.value)}
            placeholder="Write something"
          />
        </div>
      )}
      <button
        className="btn btn-primary mt-4"
        onClick={submitHandler}
        disabled={report === ""}
      >
        Submit
      </button>
    </div>
  );
};

export default ReportPost;
